import { createSlice } from "@reduxjs/toolkit";

interface SignupState {
    email: string;
    password: string;
}

const initialState: SignupState = {
    email: "",
    password: "",
};

const signupSlice = createSlice({
    name: "signupSlice",
    initialState,
    reducers: {
        setSignupDetails(state, action) {
            state.email = action.payload.email;
            state.password = action.payload.password;
        },
        clearSignupDetails(state) {
            state.email = "";
            state.password = "";
        },
    },
});

export const { setSignupDetails, clearSignupDetails } = signupSlice.actions;
export default signupSlice.reducer;
